<template>
  <div class="promoter-list" ref="containers">
	<div class="promoter-header">
		<div class="search acea-row row-between-wrapper">
		  <form @submit.prevent="submitForm">
		    <div class="input">
		      <input placeholder="点击搜索会员名称" v-model="screen.keyword" @keyup="keywordkeyup" />
		      <span v-if="isclose" @click="closesearch" class="iconfont icon-guanbi"></span>
			  <div @click="submitForm" class="iconfont icon-sousuo2"></div>
		    </div>
		  </form>
		</div>
		<div class="navbox">
			<div class="nav acea-row row-around">
			  <div
				class="item"
				:class="screen.grade == 0 ? 'on' : ''"
				@click="checkGrade(0)"
			  >
				全部客户
			  </div>
			  <div
				class="item"
				:class="screen.grade == 1 ? 'on' : ''"
				@click="checkGrade(1)"
			  >
				星标客户
			  </div>
			  <div
				class="item"
				:class="screen.grade == 2 ? 'on' : ''"
				@click="checkGrade(2)"
			  >
				有效客户
			  </div>
			  <div
				class="item"
				:class="screen.grade == 3 ? 'on' : ''"
				@click="checkGrade(3)"
			  >
				下单客户
			  </div>
			  <div
				class="item"
				:class="screen.grade == 5 ? 'on' : ''"
				@click="checkGrade(5)"
			  >
				待生效客户
			  </div>
			  <div
				class="item"
				:class="screen.grade == 4 ? 'on' : ''"
				@click="checkGrade(4)"
			  >
				失效客户
			  </div>
			  
			</div>
		</div>
		<div class="statistical-page">
		  <div class="navs">
			  <div
			    class="item"
			    :class="time == 'total' ? 'on' : ''"
			    @click="setTime('total')"
			  >
			    全部
			  </div>
		      <div
		        class="item"
		        :class="time == 'today' ? 'on' : ''"
		        @click="setTime('today')"
		      >
		        今天
		      </div>
		      <div
		        class="item"
		        :class="time == 'yesterday' ? 'on' : ''"
		        @click="setTime('yesterday')"
		      >
		        昨天
		      </div>
		      <div
		        class="item"
		        :class="time == 'seven' ? 'on' : ''"
		        @click="setTime('seven')"
		      >
		        最近7天
		      </div>
		      <!-- <div
		        class="item"
		        :class="time == 'month' ? 'on' : ''"
		        @click="setTime('month')"
		      >
		        本月
		      </div> -->
		      <div
		        class="item"
		        :class="time == 'date' ? 'on' : ''"
		        @click="dateTitle"
		      >
		        <!-- <span class="iconfont icon-xiangxia"></span>
		        <span v-for="(value, index) in renderValues" :key="index">
		          {{ value }}</span
		        > -->
		        自定义
		      </div>
		  </div>
		  <div class="calendar-wrapper" :class="current === true ? 'on' : ''">
		    <div class="calendar">
		      <Calendar
		        :clean="clean"
		        :lunar="lunar"
		        ref="calendar"
		        :range="isrange"
		        :multi="ismulti"
		        @select="select"
		        @next="next"
		        @prev="prev"
		        :value="value"
		        :weekSwitch="weekSwitch"
		        :monthRange="monthRange"
		        rangeMonthFormat="yyyy年MM月"
		        monFirst
		        responsive
		        :begin="[1992, 5, 20]"
		        :end="[2049, 5, 20]"
		      />
		    </div>
		  </div>
		  <div
		    class="mask"
		    @touchmove.prevent
		    v-show="current === true"
		    @click="close"
		  ></div>
		</div>
	</div>
	<div v-if="spreadList.length > 0" style="margin-top: 3rem;">
		<div class="total-ordernum">
			<p>共<strong>{{ first }}</strong>个客户</p>
		</div>
		<div class="list list-padd">
		  <div :class="fixedState === true ? 'sortList' : ''">
			<div
			  class="item acea-row row-between-wrapper"
			  v-for="(val, index) in spreadList"
			  :key="index"
			>
			  <div class="picTxt acea-row row-between-wrapper">
				<div class="pictrue" :class="val.status == 3 ? 'gray' : ''">
					<img :src="val.avatar" />
					<!-- <span v-if="val.id != null && val.statuspr == 2" class="fenxiao">分销员</span> -->
				</div>
				<div class="text">
				  <div class="name line1">{{ val.nickname }}</div>
				  <div>成交额：<strong>{{ val.numberCount ? val.numberCount : 0 }}</strong>&nbsp;&nbsp;订单数：<strong>{{ val.orderCount }}</strong></div>
				  <div>最近下单时间: {{ val.time }}</div>
				  <div>渠道来源：{{ val.user_type_text }}</div>
				</div>
			  </div>
			  <!-- <div class="right">
				<div>
				  <span class="font-color-red">{{ val.childCount }}</span> 人
				</div>
				<div>{{ val.orderCount }} 单</div>
				<div>{{ val.numberCount ? val.numberCount : 0 }} 元</div>
			  </div> -->
			</div>
		  </div>
		</div>
	</div>
	<div v-else class="no-customer">
		<img src="@assets/images/no-customer.png" alt="">
		<p>暂时没有客户哦</p>
	</div>
    <Loading :loaded="loaded" :loading="loading"></Loading>
  </div>
</template>
<script>
import Calendar from "mpvue-calendar";
import "mpvue-calendar/src/browser-style.css";
import { getStatisticsMonth, getStatisticsTime } from "../../../api/admin";
const year = new Date().getFullYear();
const month = new Date().getMonth() + 1;
const day = new Date().getDate();
import { getSpreadUser } from "../../../api/user";
import Loading from "@components/Loading";
export default {
  name: "PromoterList",
  components: {
    Loading,
	Calendar
  },
  props: {},
  data: function() {
    return {
      fixedState: false,
      screen: {
        page: 1,
        limit: 15,
        grade: 0,
        keyword: "",
		type:1,
        sort: "",
		time:0
      },
      childCount: 2,
      numberCount: 2,
      orderCount: 2,
      loaded: false,
      loading: false,
      spreadList: [],
      first: "",
      second: "",
	  isclose:false,
	  value: [[year, month, day - 1], [year, month, day]],
	  isrange: true,
	  weekSwitch: false,
	  ismulti: false,
	  monFirst: true,
	  clean: false, //简洁模式
	  lunar: false, //显示农历
	  renderValues: [],
	  monthRange: [],
	  current: false,
	  where: {
	    start: "",
	    stop: "",
	    type: ""
	  },
	  time: "", //时间|today=今天|yesterday=昨天|month=本月
	  title: "", //时间|today=今天|yesterday=昨天|month=本月
    };
  },
  mounted: function() {
	this.handelRenderValues();
	this.setTime(this.$route.params.time);
	// this.setType(this.$route.params.type);
    this.getSpreadUsers();
    this.$scroll(this.$refs.containers, () => {
      !this.loading && this.getSpreadUsers();
    });
  },
  watch: {
	"$route.params": function(newVal) {
	  var that = this;
	  if (newVal != undefined) {
	    // that.setType(newVal.type);
	    that.setTime(newVal.time);
		that.screen.page = 1;
		that.loaded = false;
		that.loading = false;
		that.spreadList = [];
	    that.getSpreadUsers();
	  }
	},
    "screen.sort": function() {
      this.screen.page = 1;
      this.loaded = false;
      this.loading = false;
      this.spreadList = [];
      this.getSpreadUsers();
    }
  },
  computed: {
    monthRangeText() {
      return this.monthRange.length ? "固定" : "指定范围";
    }
  },
  methods: {
    // handleScroll: function() {
    //   var scrollTop =
    //     document.documentElement.scrollTop || document.body.scrollTop;
    //   var offsetTop = document.querySelector(".header").clientHeight;
    //   if (scrollTop >= offsetTop) {
    //     this.fixedState = true;
    //   } else {
    //     this.fixedState = false;
    //   }
    // },
	// 搜索
    submitForm: function() {
      this.screen.page = 1;
      this.loaded = false;
      this.loading = false;
      this.spreadList = [];
      this.getSpreadUsers();
    },
	keywordkeyup:function(){
		this.isclose = true;
	},
	closesearch:function(){
		this.screen.keyword = "";
		this.submitForm();
		this.isclose = false;
	},
	// 获取列表
    getSpreadUsers: function() {
      let that = this,
        screen = that.screen;
      if (that.loaded || that.loading) return;
      that.loading = true;
      getSpreadUser(screen).then(
        res => {
		  that.spreadList.push.apply(that.spreadList, res.data.list);
          that.loading = false;
          that.loaded = res.data.list.length < that.screen.limit; //判断所有数据是否加载完成；
          that.screen.page = that.screen.page + 1;
          that.first = res.data.total;
          // that.second = res.data.totalLevel;
        },
        error => {
          that.$dialog.message(error.msg);
		  setTimeout(function(){
			that.$router.push('/');  
		  },1000);
        },
        300
      );
    },
	
	//切换客户类型
    checkGrade: function(val) {
      if (val == this.screen.grade) return;
      else {
        this.screen.page = 1;
        this.screen.grade = val;
        this.loading = false;
        this.loaded = false;
        this.spreadList = [];
        this.getSpreadUsers();
      }
    },
    
	setTime: function(time) {
	  let that = this;
	  this.time = time;
	  var year = new Date().getFullYear(),
	    month = new Date().getMonth() + 1,
	    day = new Date().getDate();
	  switch (time) {
		case "total":
		  this.where.start =
		    new Date(Date.parse(2020 + "/" + 1 + "/" + 1)).getTime() /
		    1000;
		  this.where.stop =
		    new Date(Date.parse(year + "/" + month + "/" + day)).getTime() /
		      1000 +
		    24 * 60 * 60 -
		    1;
		  that.title = "全部";
		  that.screen.time = 0;
		  this.screen.page = 1;
		  this.loaded = false;
		  this.loading = false;
		  this.spreadList = [];
		  that.getSpreadUsers();
		  break;
	    case "today":
	      this.where.start =
	        new Date(Date.parse(year + "/" + month + "/" + day)).getTime() /
	        1000;
	      this.where.stop =
	        new Date(Date.parse(year + "/" + month + "/" + day)).getTime() /
	          1000 +
	        24 * 60 * 60 -
	        1;
	      that.title = "今日";
		  that.screen.time = "today";
		  this.screen.page = 1;
		  this.loaded = false;
		  this.loading = false;
		  this.spreadList = [];
	      that.getSpreadUsers();
	      break;
	    case "yesterday":
	      this.where.start =
	        new Date(Date.parse(year + "/" + month + "/" + day)).getTime() /
	          1000 -
	        24 * 60 * 60;
	      this.where.stop =
	        new Date(Date.parse(year + "/" + month + "/" + day)).getTime() /
	          1000 -
	        1;
	      that.title = "昨日";
		  that.screen.time = "yesterday";
		  this.screen.page = 1;
		  this.loaded = false;
		  this.loading = false;
		  this.spreadList = [];
	      that.getSpreadUsers();
	      break;
	    // case "month":
	    //   this.where.start =
	    //     new Date(year, new Date().getMonth(), 1).getTime() / 1000;
	    //   this.where.stop = new Date(year, month, 1).getTime() / 1000 - 1;
	    //   this.title = "本月";
	    //   // this.getSpreadUsers();
	    //   break;
	    case "seven":
	      this.where.start =
	        new Date(Date.parse(year + "/" + month + "/" + day)).getTime() /
	          1000 +
	        24 * 60 * 60 -
	        7 * 3600 * 24;
	      this.where.stop =
	        new Date(Date.parse(year + "/" + month + "/" + day)).getTime() /
	          1000 +
	        24 * 60 * 60 -
	        1;
	      that.title = "七日";
		  that.screen.time = "lately7";
		  this.screen.page = 1;
		  this.loaded = false;
		  this.loading = false;
		  this.spreadList = [];
	      that.getSpreadUsers();
	      break;
	  }
	},
	// setType: function(type) {
	//   switch (type) {
	//     case "1":
	//       this.where.type = 1;
	//       break;
	//     case "2":
	//       this.where.type = 2;
	//       break;
	//   }
	// },
	clickSomeThing(data) {
	  console.log(data);
	  this.value = [[2019, 4, 1], [2019, 4, 8]];
	},
	setMonthRange() {
	  this.monthRange = this.monthRange.length ? [] : ["2019-4", "2020-1"];
	},
	switchMode() {
	  this.weekSwitch = !this.weekSwitch;
	  setTimeout(() => {
	    this.$refs.calendar.renderer(2019, 1); //渲染2018年8月份
	  }, 0);
	},
	handelRenderValues(data) {
	  if (this.ismulti) {
	    this.renderValues = this.value.map(v => v.join("-"));
	  } else if (this.isrange) {
	    const values = [];
	    data || this.value;
	    this.value.forEach((v, i) => {
	      values.push(v.join("-"));
	      if (!i) {
	        values.push("~");
	      }
	    });
	    this.renderValues = values;
	  } else {
	    this.renderValues = [this.value.join("-")];
	  }
	},
	multiMode() {
	  this.ismulti = true;
	  this.isrange = false;
	  this.value = [[year, month, 16], [year, month, 18]];
	  this.handelRenderValues();
	  this.$refs.calendar.renderer(year, month);
	},
	rangeMode() {
	  this.ismulti = false;
	  this.isrange = true;
	  this.value = [[year, month, 16], [year, month, 22]];
	  this.handelRenderValues();
	  this.$refs.calendar.renderer(year, month);
	},
	valueMode() {
	  this.ismulti = false;
	  this.isrange = false;
	  this.value = [year, month, 16];
	  this.handelRenderValues();
	  this.$refs.calendar.renderer(year, month);
	},
	selectMonth(month, year) {
	  console.log(year, month);
	},
	prev(y, m, w) {
	  console.log(y, m, w);
	},
	next(year, month, week) {
	  console.log(year, month, week);
	},
	selectYear(year) {
	  console.log(year);
	},
	setToday() {
	  this.$refs.calendar.setToday();
	},
	dateInfo() {
	  const info = this.$refs.calendar.dateInfo(2018, 8, 23);
	  console.log(info);
	},
	renderer() {
	  if (this.monthRange.length) {
	    this.monthRange = ["2018-8", "2018-8"];
	  }
	  this.$refs.calendar.renderer(2018, 8); //渲染2018年8月份
	},
	select(val, val2) {
	  if (this.isrange) {
	    this.handelRenderValues([val, val2]);
	  } else if (this.ismulti) {
	    this.handelRenderValues(val);
	  } else {
	    this.handelRenderValues([val]);
	  }
	  if (
	    this.where.start != new Date(val) / 1000 ||
	    this.where.stop != new Date(val2) / 1000 + 24 * 60 * 60 - 1
	  ) {
	    this.time = "date";
	    this.title = "";
	    this.where.start =
	      new Date(Date.parse(val[0] + "/" + val[1] + "/" + val[2])).getTime() /
	      1000;
	    this.where.stop =
	      new Date(
	        Date.parse(val2[0] + "/" + val2[1] + "/" + val2[2])
	      ).getTime() /
	        1000 +
	      24 * 60 * 60 -
	      1;
		this.screen.time = val[0] + '-' + val[1] + '-' + val[2] + ' - ' + val2[0] + '-' + val2[1] + '-' + val2[2];
		this.screen.page = 1;
		this.loaded = false;
		this.loading = false;
		this.spreadList = [];
	    this.getSpreadUsers();
	  }
	},
	dateTitle: function() {
	  this.current = true;
	},
	close: function() {
	  this.current = false;
	},
	
  }
};
</script>
<style scoped>
.promoter-list .search.acea-row.row-between-wrapper{align-items: center;}
.promoter-list .search .input input{
	text-align: left;
	text-indent: 1em;
	width: 6.8rem;
}
.promoter-list .search .input{width: 6.9rem;}
.promoter-list .search .input .icon-guanbi{right: 12%;}
.promoter-header{background-color: #fff;padding: 0.2rem 0;box-shadow: 0 0 5px #ccc;height: 3rem;position: fixed;top: 0;left: 0;z-index: 999;}
.sousuo{font-size: 0.28rem;}
.navbox{width: 100%;overflow-x: scroll;}
.promoter-list .nav{width: 140%;}
.statistical-page .navs{position: absolute; top: 2rem;display: flex;justify-content: space-between;padding: 0 0.2rem;}
.statistical-page .navs .item{font-size: 0.28rem;margin-left: 0;}
.total-ordernum{padding: 0.3rem 0.2rem;}
.total-ordernum p{font-size: 0.26rem;color: #999;}
.total-ordernum p strong{font-size: 0.28rem;color: #333;}
.list-padd{padding: 0 0.2rem;margin-bottom: 0.2rem;}
.promoter-list .list-padd .item{padding: 0.2rem 0.3rem;margin-top: 0.2rem;border-radius: 5px;height: auto;}
.promoter-list .list-padd .item:first-child{margin-top: 0;}
.promoter-list .list .item .picTxt{width: auto;}
.promoter-list .list .item .picTxt .text{width: auto;margin-left: 0.2rem;}
.promoter-list .list .item .picTxt .text>div{margin-bottom: 0.1rem;}
.acea-row.row-between-wrapper{align-items: normal;}
.promoter-list .list .item .picTxt .text strong{color: #333;}
.promoter-list .list .item .picTxt .pictrue{position: relative;}
.promoter-list .list .item .picTxt .gray{opacity: 0.3;}
.fenxiao{
	color: #fff;
	font-size: 0.22rem;
	text-align: center;
	border-radius: 20px;
	margin-left: 0.1rem;
	padding: 0 0.1rem;
	position: absolute;
	left: 0;
	bottom: 0;
	background-color: #fd7226;
}
.calendar-wrapper {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 777;
  transform: translate3d(0, 100%, 0);
  transition: all 0.3s cubic-bezier(0.25, 0.5, 0.5, 0.9);
}
.calendar-wrapper.on {
  transform: translate3d(0, 0, 0);
}
.no-customer img{
	display: block;
	width: 50%;
	margin: 0 auto;
	margin-top: 70%;
}
.no-customer p{text-align: center;color: #999;margin-top: 0.2rem;}
</style>
